import React, { createContext, useContext, useEffect, useState } from 'react';
import { Player } from '../models/player';
import cuescoreService from '../api/CuescoreService';

type PlayerContextType = {
    player: Player | null;
    setPlayer: (player: Player | null) => void;
};

export const PlayerContext = createContext<PlayerContextType | undefined>(undefined);
const playerKey = "myPlayer";

export const PlayerProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [player, setPlayerState] = useState<Player | null>(null);

    // Load player from localStorage on mount
    useEffect(() => {
        const playerData = localStorage.getItem(playerKey);
        if (playerData) {
            setPlayerState(JSON.parse(playerData));
        }
    }, []);

    // Update localStorage whenever player changes
    const setPlayer = async (newPlayer: Player | null) => {

        console.log("Setplayer", newPlayer);
        if (newPlayer) {
            if (!newPlayer.imageUrl) {
                if (newPlayer.altId) {
                    const csPlayer = await cuescoreService.getPlayerInfo(newPlayer.altId);
                    newPlayer.imageUrl = csPlayer.image;
                    newPlayer.countryImageUrl = csPlayer.country.image;
                }
                else {
                    newPlayer.imageUrl = "/butler.png";
                }
            }

            localStorage.setItem(playerKey, JSON.stringify(newPlayer));
        } else {
            localStorage.removeItem(playerKey);
        }
        setPlayerState(newPlayer);
    };

    return (
        <PlayerContext.Provider value={{ player, setPlayer }}>
            {children}
        </PlayerContext.Provider>
    );
};

export const usePlayer = () => {
    const context = useContext(PlayerContext);
    if (!context) {
        throw new Error('usePlayer must be used within a PlayerProvider');
    }
    return context;
};